import { render } from "./ClientConfig.vue?vue&type=template&id=d51f4772"
import script from "./ClientConfig.vue?vue&type=script&lang=js"
export * from "./ClientConfig.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__